<template>
  <reference-filter
    class="reference-filter-multiple-text"
    :label="label"
    :count="count"
  >
    <string-list-input
      :inputs.sync="valuesModel"
      :placeholder="placeholder"
    />
  </reference-filter>
</template>

<script>
import StringListInput from '@/components/Common/StringListInput';
import ReferenceFilter from './ReferenceFilter';

export default {
  name: 'ReferenceFilterMultipleText',
  components: { ReferenceFilter, StringListInput },
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Enter value',
    },
    values: {
      type: Array,
      default: null,
    },
  },
  emits: ['update:values'],
  computed: {
    valuesModel: {
      get: function () {
        return this.values;
      },
      set: function (value) {
        this.$emit('update:values', value);
      },
    },
    count() {
      // Count the number of non-empty fields
      const maybeCount = this.values?.reduce((count, value) => {
        if (value && value.trim()) {
          count++;
        }
        return count;
      }, 0);
      return maybeCount ?? 0;
    },
  },
};
</script>
